import LogoAriston from "../../../../images/content/introduction/direct-members/logo-ariston.jpg";
import LogoBeko from "../../../../images/content/introduction/direct-members/logo-beko.jpg";
import LogoBSH from "../../../../images/content/introduction/direct-members/logo-bsh.jpg";
import LogoDaikin from "../../../../images/content/introduction/direct-members/logo-daikin.jpg";
import LogoDelonghi from "../../../../images/content/introduction/direct-members/logo-delonghi.jpg";
import LogoDyson from "../../../../images/content/introduction/direct-members/logo-dyson.jpg";
import LogoElectrolux from "../../../../images/content/introduction/direct-members/logo-electrolux.jpg";
import LogoGroupeAtlantic from "../../../../images/content/introduction/direct-members/logo-groupe-atlantic.jpg";
import LogoHaier from "../../../../images/content/introduction/direct-members/logo-haier.jpg";
import LogoHisense from "../../../../images/content/introduction/direct-members/logo-hisense.jpg";
import LogoIrobot from "../../../../images/content/introduction/direct-members/logo-irobot.jpg";
import LogoKitchenAid from "../../../../images/content/introduction/direct-members/logo-kitchenaid.jpg";
import LogoLG from "../../../../images/content/introduction/direct-members/logo-lg.jpg";
import LogoLiebherr from "../../../../images/content/introduction/direct-members/logo-liebherr.jpg";
import LogoMidea from "../../../../images/content/introduction/direct-members/logo-midea.jpg";
import LogoMiele from "../../../../images/content/introduction/direct-members/logo-miele.jpg";
import LogoPanasonic from "../../../../images/content/introduction/direct-members/logo-panasonic.jpg";
import LogoPhilips from "../../../../images/content/introduction/direct-members/logo-philips.jpg";
import LogoPG from "../../../../images/content/introduction/direct-members/logo-pg.jpg";
import LogoSamsung from "../../../../images/content/introduction/direct-members/logo-samsung.jpg";
import LogoGroupeSEB from "../../../../images/content/introduction/direct-members/logo-groupe-seb.jpg";
import LogoSmeg from "../../../../images/content/introduction/direct-members/logo-smeg.jpg";
import LogoVersuni from "../../../../images/content/introduction/direct-members/logo-versuni.jpg";
import LogoVestel from "../../../../images/content/introduction/direct-members/logo-vestel.jpg";
import LogoVorwerk from "../../../../images/content/introduction/direct-members/logo-vorwerk.jpg";

export const directMembers = [
	{
		id: "applia-member-ariston-group",
		url: "https://www.aristongroup.com/en/",
		imageUrl: LogoAriston,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.ariston.imageAlt",
	},
	{
		id: "applia-member-beko",
		url: "https://www.bekoeurope.com/",
		imageUrl: LogoBeko,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.beko.imageAlt",
	},
	{
		id: "applia-member-bsh",
		url: "https://www.bsh-group.com/",
		imageUrl: LogoBSH,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.bsh.imageAlt",
	},
	{
		id: "applia-member-daikin",
		url: "https://www.daikin.eu/en_us/customers.html",
		imageUrl: LogoDaikin,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.daikin.imageAlt",
	},
	{
		id: "applia-member-delonghi",
		url: "https://www.delonghigroup.com/en",
		imageUrl: LogoDelonghi,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.délonghi.imageAlt",
	},
	{
		id: "applia-member-dyson",
		url: "https://www.dyson.co.uk/",
		imageUrl: LogoDyson,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.dyson.imageAlt",
	},
	{
		id: "applia-member-electrolux",
		url: "https://www.electroluxgroup.com/en/",
		imageUrl: LogoElectrolux,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.electrolux.imageAlt",
	},
	{
		id: "applia-member-groupe-atlantic",
		url: "https://www.groupe-atlantic.fr/en/",
		imageUrl: LogoGroupeAtlantic,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.atlantic.imageAlt",
	},
	{
		id: "applia-member-haier",
		url: "https://corporate.haier-europe.com/en/",
		imageUrl: LogoHaier,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.haier.imageAlt",
	},
	{
		id: "applia-member-hisense",
		url: "https://www.hisense-europe.com/en/",
		imageUrl: LogoHisense,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.hisense.imageAlt",
	},
	{
		id: "applia-member-irobot",
		url: "https://www.irobot.com/",
		imageUrl: LogoIrobot,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.irobot.imageAlt",
	},
	{
		id: "applia-member-kitchenaid",
		url: "https://www.irobot.com/",
		imageUrl: LogoKitchenAid,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.kitchenaid.imageAlt",
	},
	{
		id: "applia-member-LG",
		url: "https://www.lg.com/global/",
		imageUrl: LogoLG,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.lg.imageAlt",
	},
	{
		id: "applia-member-liebherr",
		url: "https://www.liebherr.com",
		imageUrl: LogoLiebherr,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.liebherr.imageAlt",
	},
	{
		id: "applia-member-midea",
		url: "https://www.midea.com/de/",
		imageUrl: LogoMidea,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.midea.imageAlt",
	},
	{
		id: "applia-member-miele",
		url: "https://www.miele.de",
		imageUrl: LogoMiele,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.miele.imageAlt",
	},
	{
		id: "applia-member-panasonic",
		url: "https://www.panasonic.eu",
		imageUrl: LogoPanasonic,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.panasonic.imageAlt",
	},
	{
		id: "applia-member-philips",
		url: "https://www.philips.com",
		imageUrl: LogoPhilips,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.philips.imageAlt",
	},
	{
		id: "applia-member-procter-and-gamble",
		url: "https://fr-be.pg.com/",
		imageUrl: LogoPG,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.procter-and-gamble.imageAlt",
	},
	{
		id: "applia-member-samsung",
		url: "https://www.samsung.com",
		imageUrl: LogoSamsung,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.samsung.imageAlt",
	},
	{
		id: "applia-member-groupe-seb",
		url: "https://www.groupeseb.com",
		imageUrl: LogoGroupeSEB,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.groupe-seb.imageAlt",
	},
	{
		id: "applia-member-smeg",
		url: "https://www.smeg.com",
		imageUrl: LogoSmeg,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.smeg.imageAlt",
	},
	{
		id: "applia-member-versuni",
		url: "https://www.versuni.com",
		imageUrl: LogoVersuni,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.versuni.imageAlt",
	},
	{
		id: "applia-member-vestel",
		url: "https://www.vestel.com/",
		imageUrl: LogoVestel,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.vestel.imageAlt",
	},
	{
		id: "applia-member-vorwerk",
		url: "https://www.vorwerk.com",
		imageUrl: LogoVorwerk,
		imageAlt: "pages.introduction.appliaDirectMembers.blocks.grid.vorwerk.imageAlt",
	},
];
